import {AbstractControl, ValidatorFn} from '@angular/forms';

import * as moment_ from 'moment';

import {MinDateValidatorKey} from './custom-validator-keys';

const moment = moment_;

export function MinDateValidator(date: string): ValidatorFn {
    return (control: AbstractControl): { [MinDateValidatorKey]: boolean } | null => {
        if (!moment(date).isValid()) {
            console.warn('Invalid date for comparison.');

            return null;
        }

        const controlValue = control.value;

        if (controlValue) {
            const baseDate = moment(date).utc(false);

            const controlDate = moment(controlValue).utc(false);

            if (controlDate.isSameOrBefore(baseDate)) {
                return {[MinDateValidatorKey]: true};
            }
        }

        return null;
    };
}
